module.exports = __webpack_public_path__ + "img/bayreuth_schloss2.02afbeca.jpg";